import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
import InputSelect from '../ui/inputSelect';
import ITSVideoPlayer from '../../utils/ITS-videoPlayer'; // api

import { setTerminalRelatedCameraAPI } from '../../api/areaAPI';
var t = i18n.getFixedT(null, 'terminal-dashboard');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var RelatedCameraEdit = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  var dispatch = useDispatch();
  var id = props.id,
      onClose = props.onClose,
      onConfirm = props.onConfirm,
      dialogData = props.dialogData,
      allCameraList = props.allCameraList;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      relatedCameras = _useState2[0],
      setRelatedCameras = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      previewCamera = _useState4[0],
      setPreviewCamera = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      tempSelectedCamera = _useState6[0],
      setTempSelectedCamera = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      error = _useState8[0],
      setError = _useState8[1];

  var form_ref = useRef(null);
  var isChange = useRef(false);

  var handleConfirm = function handleConfirm() {
    if (!isChange.current) return onClose();

    var newList = _.map(relatedCameras, function (el) {
      return el.id;
    });

    setTerminalRelatedCameraAPI(contextRoot, false, dialogData.id, newList).then(function (result) {
      onConfirm();
    }).catch(function (error) {
      console.log(error);
    });
  };

  var handleChangeInputSelect = function handleChangeInputSelect(item) {
    if (_.isEmpty(item) || item === 'all') return setTempSelectedCamera(null);
    setTempSelectedCamera(item);
  };

  var handleSelectPreviewCamera = function handleSelectPreviewCamera(data) {
    if (data) return setPreviewCamera(data);
    if (tempSelectedCamera) return setPreviewCamera(tempSelectedCamera);
  };

  var handleAddRelatedCameras = function handleAddRelatedCameras() {
    if (!tempSelectedCamera) return;
    var list = isChange.current ? relatedCameras : dialogData.relatedCameras; // check up whether item is already add in list

    var isExisted = _.find(list, function (el) {
      return el.id === tempSelectedCamera.id;
    });

    if (!isExisted) {
      setRelatedCameras([].concat(_toConsumableArray(list), [tempSelectedCamera]));
      isChange.current = true;
    }
  };

  var handleDeleteRelatedCamera = function handleDeleteRelatedCamera(id) {
    var list = isChange.current ? relatedCameras : dialogData.relatedCameras;

    var newList = _.remove(list, function (el) {
      return el.id !== id;
    });

    setRelatedCameras(newList);
    isChange.current = true;
  };

  useEffect(function () {
    return function () {
      setRelatedCameras(null);
      setTempSelectedCamera(null);
      isChange.current = false;
    };
  }, []);
  var fields = {};

  _.set(fields, 'filterCameras', {
    label: t('lbl-camera'),
    editor: null,
    formatter: function formatter(val, row) {
      var options = allCameraList.map(function (el) {
        return _objectSpread(_objectSpread({}, el), {}, {
          value: el.id,
          text: el.name
        });
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputSelect, {
        className: "inputSelect",
        defaultOptionText: t('lbl-please-selecte-camera'),
        options: options,
        onChange: handleChangeInputSelect
      }), /*#__PURE__*/React.createElement("i", {
        className: "fas fa-plus first",
        title: t('lbl-add'),
        onClick: function onClick() {
          return handleAddRelatedCameras();
        }
      }), /*#__PURE__*/React.createElement("i", {
        className: "fas fa-eye",
        title: t('lbl-preview-camera'),
        onClick: function onClick() {
          return handleSelectPreviewCamera();
        }
      }));
    }
  });

  _.set(fields, 'relatedCameras', {
    label: t('lbl-related-camera'),
    editor: null,
    formatter: function formatter(val, row) {
      if (row.length === 0) return /*#__PURE__*/React.createElement("div", null, t('lbl-no-related-camera'));
      return /*#__PURE__*/React.createElement("div", {
        className: "relatedCameras-block"
      }, _.map(row, function (el) {
        return /*#__PURE__*/React.createElement("div", {
          className: cx('camera')
        }, /*#__PURE__*/React.createElement("span", {
          className: !_.isEmpty(previewCamera) && previewCamera.id === el.id ? 'selected' : '',
          onClick: function onClick() {
            return handleSelectPreviewCamera(el);
          }
        }, el.name), /*#__PURE__*/React.createElement("a", {
          onClick: function onClick() {
            return handleDeleteRelatedCamera(el.id);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fas fa-times"
        })));
      }));
    }
  });

  _.set(fields, 'previewCamera', {
    label: t('lbl-preview-camera'),
    editor: null,
    formatter: function formatter(val, row) {
      if (!previewCamera) return /*#__PURE__*/React.createElement("div", null);
      return /*#__PURE__*/React.createElement("div", {
        className: "tvwall"
      }, /*#__PURE__*/React.createElement("span", null, previewCamera.name), /*#__PURE__*/React.createElement(ITSVideoPlayer, {
        videoData: previewCamera
      }));
    }
  }); // dailog action


  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: onClose
  });

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    // disabled: !formValid,
    handler: handleConfirm
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('lbl-edit'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form-left"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields // onChange={handleDataChange}
    ,
    value: isChange.current ? relatedCameras : dialogData.relatedCameras
  }));
});
RelatedCameraEdit.defaultProps = {
  id: 'g-related-camera-edit'
};
RelatedCameraEdit.propTypes = {
  id: PropTypes.string
};
export default RelatedCameraEdit;